import type { U2104LogicalUnit } from '../../../../U2104Service';

/** Choix catalogue UL pour le dialogue de modification du catalogue org. */
export interface U2104AvailableLogicalUnitChoice {
  id: string;
  logicalUnitCode: string;
  logicalUnitDescription: string;
  idChecked: boolean;
  /** True si encore liée à un rôle ou une affiliation — non décochable. */
  disabled: boolean;
  logicalUnitCategoryId?: string | null;
  logicalUnitCategoryCode?: string | null;
  logicalUnitCategoryLabelFr?: string | null;
  logicalUnitCategoryLabelEn?: string | null;
  logicalUnitCategorySortOrder?: number | null;
}

/** Trie par code d’unité logique (ordre naturel numérique). */
export function u2104SortLogicalUnitsByCode<T extends { logicalUnitCode: string }>(items: readonly T[]): T[] {
  return [...items].sort((a, b) =>
    a.logicalUnitCode.localeCompare(b.logicalUnitCode, undefined, { numeric: true, sensitivity: 'base' }),
  );
}

/**
 * Construit la liste à cases pour le dialogue catalogue org.
 * L’ordre d’affichage / regroupement est appliqué à l’UI via `u2104GroupLogicalUnitsByCategory`.
 * - Cochées si déjà dans le catalogue org ou référencées par rôle/affiliation
 * - Désactivées si référencées (retrait impossible côté métier)
 */
export function u2104BuildAvailableLogicalUnitChoices(
  logicalUnits: readonly U2104LogicalUnit[],
  selectedLogicalUnitIds: ReadonlySet<string>,
  referencedLogicalUnitCodes: ReadonlySet<string>,
): U2104AvailableLogicalUnitChoice[] {
  return u2104SortLogicalUnitsByCode(logicalUnits).map((lu) => {
    const referenced = referencedLogicalUnitCodes.has(lu.logicalUnitCode);
    return {
      id: lu.id,
      logicalUnitCode: lu.logicalUnitCode,
      logicalUnitDescription: lu.logicalUnitDescription,
      idChecked: selectedLogicalUnitIds.has(lu.id) || referenced,
      disabled: referenced,
      logicalUnitCategoryId: lu.logicalUnitCategoryId ?? null,
      logicalUnitCategoryCode: lu.logicalUnitCategoryCode ?? null,
      logicalUnitCategoryLabelFr: lu.logicalUnitCategoryLabelFr ?? null,
      logicalUnitCategoryLabelEn: lu.logicalUnitCategoryLabelEn ?? null,
      logicalUnitCategorySortOrder: lu.logicalUnitCategorySortOrder ?? null,
    };
  });
}
